import { Text as RNText } from 'react-native';
import { EventProvider } from 'react-native-outside-press';
import Text from './text';
import Spacer from './spacer';
import Camera from './camera';
import Colors from './colors';
import ContentCard from './content-card';
import ContentGroup from './content-group';
import DividerLine from './divider-line';
import Icon from './icon';
import ProgressBar from './progress-bar';
import Badge from './badge';
import DocumentLink from './document-link';
import DocumentRow from './document-row';
import Status from './status';
import Alert from './alert';
import * as Snackbar from './snackbar';
import BreakdownRow from './breakdown-row';
import LabelDataPair from './label-data-pair';
import NotificationRow from './notification-row';
import fonts from './assets/fonts';
import images from './assets/images';
import illustrations from './assets/illustrations';
import SvgRenderer from './svg-renderer';
import Referrals from './referrals';
import Requirement from './requirement';
import Panel from './panel';
import Payment from './payment';
import Voucher from './voucher';
import Button from './button';
import SectionTitle from './section-title';
import KycRequirements from './kyc-requirements';
import Input from './input';
import HighlightedContent from './highlighted-content';
import Wizard from './wizard-headers-and-footers';
import Breadcrumb from './breadcrumb';
import AdvanceDetailsHeader from './advance-details-header';
import Widget from './widget';
import SpecialCard from './special-card';
import NavigationListItem from './navigation-list-item';
import NavigationMenu from './navigation-menu';
import Tooltip from './tooltip';
import AdvanceBreakdown from './advance-breakdown';
import Transaction from './transaction';
import HeadingGroup from './heading-group';
import Overlay from './overlay';
import BottomSheet from './bottom-sheet';
import Toggle from './toggle';
import Instructions from './instructions';
import PageEnd from './page-end';
import TextGroup from './text-group';
import ListItem from './list-item';
import ProgressHeader from './progress-header';
import PageControl from './page-control';
import LoginPin from './login-pin';
import SystemBar from './system-bar';
import TitleBar from './title-bar';
import PinKeypad from './pin-keypad';
import Navigation from './navigation';
import Modal from './modal';
import DatePicker from './date-picker';
import PageHandler from './page-handler';
import ErrorScreen from './error-screens';
import withLoader from './hocs/with-loader';
RNText.defaultProps = { ...RNText.defaultProps,
  allowFontScaling: false
};
export { Text, Spacer, Colors, DividerLine, Icon, ProgressBar, Badge, Status, DocumentLink, DocumentRow, Alert, Snackbar, BreakdownRow, LabelDataPair, NotificationRow, fonts, images, illustrations, SvgRenderer, Referrals, Requirement, Panel, Button, SectionTitle, HighlightedContent, ContentGroup, Input, Wizard, Breadcrumb, ContentCard, AdvanceDetailsHeader, SpecialCard, NavigationMenu, Payment, Tooltip, Voucher, Widget, NavigationListItem, Overlay, HeadingGroup, AdvanceBreakdown, KycRequirements, TextGroup, PageEnd, Instructions, Toggle, Transaction, ListItem, ProgressHeader, PageControl, LoginPin, SystemBar, TitleBar, PinKeypad, Navigation, Camera, BottomSheet, Modal, DatePicker, EventProvider, PageHandler, ErrorScreen, withLoader };
//# sourceMappingURL=index.js.map